var map = {
	"./P2-A1.svg": "6fb2",
	"./P2-A2.svg": "0a1b",
	"./P2-A3.svg": "5ff8",
	"./P2-A4.svg": "86e0",
	"./P2-A5.svg": "664f",
	"./P2-A6.svg": "5fa9",
	"./P2-A7.svg": "a1a8",
	"./P2-A8.svg": "ff4b",
	"./P2-A9.svg": "4125"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7868";